import page from '../../../page/page';
import {
  getDeliveryAddressInKlarnaSDKFormat,
  getSelectedAddressInKlarnaSDKFormat,
} from '../../../selectors/PaymentOptionSelectors/Klarna/KlarnaSelectors';
import {getUsedDeliveryAddressOnPaymentResolutionPageInAPIFormat} from '../../../selectors/PaymentResolutionSelectors';
import {
  getPudoAddressDetailsInAPIFormat,
  getPudoAddressDetailsInKlarnaSDKAttachmentFormat,
  getPudoAddressDetailsInKlarnaSDKFormat,
} from '../../../selectors/PudoKlarnaSelectors';
import {
  getDeliveryType,
  getSelectedAddressInAPIFormat,
  getSelectedResidentialAddress,
  getSettings,
  getSiteDataV2,
} from '../../../selectors/selectors';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';
import convertAddressInAPIFormat from './convertAddressInAPIFormat';
import convertAddressInKlarnaSDKAttachmentFormat from './convertAddressInKlarnaSDKAttachmentFormat';
import convertAddressInKlarnaSDKFormat from './convertAddressInKlarnaSDKFormat';
import handleKlarnaError from './handleKlarnaError';

const doAuthMetric = (attribute) => {
  try {
    doMetric('klarnaAuthorisation', attribute);
  } catch (error) {
    Track.track(error);
  }
};

export default (dispatch, getState) => (klarnaInformation) => {
  const enableKlarnaForStoreCollection = getSettings(getState())?.enable_klarna_for_store_collection;
  let formattedAddress;
  if (!page.isOnPage('payment-resolution')) {
    formattedAddress = getSelectedAddressInKlarnaSDKFormat(getState());
  } else {
    formattedAddress = getDeliveryAddressInKlarnaSDKFormat(getState());
  }
  const deliveryType = getDeliveryType(getState());
  let storeAddresses = [];
  let primaryStoreAddress = null;
  if (klarnaInformation.store_addresses) {
    storeAddresses = klarnaInformation.store_addresses;
    delete klarnaInformation.store_addresses;
  }
  if (klarnaInformation.primary_store_address) {
    primaryStoreAddress = klarnaInformation.primary_store_address;
    delete klarnaInformation.primary_store_address;
  }
  let address = formattedAddress;
  if (enableKlarnaForStoreCollection) {
    if (storeAddresses.length > 0 && primaryStoreAddress === null) {
      dispatch(handleKlarnaError('KLARNA_HANDLE_NULL_STORE_ADDRESSES',
        'Store addresses are null for store collection'));
      doAuthMetric([{name: 'authCall', value: 'failed'}]);
      return;
    }
    address = (primaryStoreAddress !== null && formattedAddress.postal_code === '')
      ? convertAddressInKlarnaSDKFormat(primaryStoreAddress, formattedAddress)
      : deliveryType === 'pudo' ? getPudoAddressDetailsInKlarnaSDKFormat(getState()) : formattedAddress;
  }
  
  const {siteName} = getSiteDataV2(getState());
  const storeAddressesKlarnaSDKFormat = storeAddresses.filter(storeAddress => storeAddress !== null)
    .map(storeAddress => convertAddressInKlarnaSDKAttachmentFormat(storeAddress, formattedAddress, siteName));
  
  if (deliveryType === 'pudo') {
    storeAddressesKlarnaSDKFormat.push(getPudoAddressDetailsInKlarnaSDKAttachmentFormat(getState()));
  }
  
  const attachmentBody = {other_delivery_address: storeAddressesKlarnaSDKFormat};
  
  const authRequestBody = {
    ...klarnaInformation,
    attachment: {
      content_type: 'application/vnd.klarna.internal.emd-v2+json',
      body: JSON.stringify(attachmentBody),
    },
  };
  
  if (address === formattedAddress) {
    authRequestBody.billing_address = address;
    authRequestBody.shipping_address = address;
  }
  
  let shippingAddressInAPIFormat;
  if (!page.isOnPage('payment-resolution')) {
    shippingAddressInAPIFormat = getSelectedAddressInAPIFormat(getState());
  } else {
    shippingAddressInAPIFormat = getUsedDeliveryAddressOnPaymentResolutionPageInAPIFormat(getState());
  }
  if (enableKlarnaForStoreCollection) {
    shippingAddressInAPIFormat = (primaryStoreAddress !== null && formattedAddress.postal_code === '')
      ? convertAddressInAPIFormat(primaryStoreAddress, shippingAddressInAPIFormat, siteName)
      : deliveryType === 'pudo' ? getPudoAddressDetailsInAPIFormat(getState()) : shippingAddressInAPIFormat;
  }
  
  return {authRequestBody, shippingAddressInAPIFormat};
};
